import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { SiftPageView } from '../Sift';
import { analyticsPage } from '../helpers/AnalyticsUtility';
import { raygunPage } from '../helpers/RaygunUtility';
import { handleNavigateForRecording } from '../helpers/ScreenRecordingUtility';

export type LocationChangeLoggerProps = {
  children: React.ReactElement;
};

/**
 * Logs the location changes to our different analytics and tracking platforms.
 *
 * This used to live directly in the `Library` component and depended on the `history` object, which is
 * deprecated and no longer directly supported outside of the `BrowserRouter`.
 */
export default function LocationChangeLogger({ children }: LocationChangeLoggerProps) {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const pathname = location.pathname;
    const route = recreateRoutePath(params, pathname);
    analyticsPage(route, pathname);
    raygunPage(route, pathname);
    SiftPageView();

    handleNavigateForRecording(route, pathname);
  }, [location]);

  return children;
}
function recreateRoutePath(params, pathname: string) {
  return Object.keys(params).reduce((pathBuilder, key) => {
    if (key === '*') {
      return pathBuilder;
    }
    return pathBuilder.replace(params[key], `:${key}`);
  }, pathname);
}
